import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pdpStateReducer';
import { IPDPState } from 'store/types/pdpStateTypes';

export const initialState: IPDPState = {
  focusedWindow: null,
  initialCategoryWindowPosition: null,
  bigBuyBarView: 'new',
  mobileView: 'main',
  previousMobileView: 'none',
  openWindows: [],
  positionOffset: 0,
  size: null,
  misc: {},
};

export const pdpStateSlice = createSlice({
  name: 'pdpState',
  initialState,
  reducers,
});

export const {
  addWindow,
  removeWindow,
  resetWindows,
  setInitialCategoryWindowPosition,
  setBigBuyBarView,
  setMobileView,
  setWindowFocus,
  setSize,
  updateMisc,
  clearMisc,
} = pdpStateSlice.actions;
export default pdpStateSlice.reducer;
